import ReactDOM from 'react-dom';
import React from "react";
import { connect, dispatch } from "react-redux";
import {
  setQuizData,
  setPreviousQuestion,
  quizSelector,
  goToStep,
  setMapsAPI
} from "redux/reducers/quiz-reducer";
import WizardToolQuestionWrapper from "./components/wizardToolQuestionWrapper/wizardToolQuestionWrapper";
import webservice from "./API/webservice.js";
import WizardToolStepIndicator from "./components/wizardToolStepIndicator/wizardToolStepIndicator.js";

class WizardTool extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mapsAPIloaded: false,
      fixedStyles: {
        top: "initial",
        position: "relative"
      },
      closeXTop: {
        top: "initial"
      },
      isSticky: false,
      mainHeight: 0,
      wizardToolTopY: 0,
      modalCloseText: "Close",
      hackBrowserBackBtn: false,
      showAsInPageWizardTool: props.Settings.ShowAsInPageWizardTool
    };

    this.closeModal = this.closeModal.bind(this);
    this.loadMapsAPI = this.loadMapsAPI.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.calcStyles = this.calcStyles.bind(this);
    this.hackBrowserBackBtn = this.hackBrowserBackBtn.bind(this);
    this.unHackBrowserBackBtn = this.unHackBrowserBackBtn.bind(this);
    this.goToStep = this.goToStep.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let isWidget = this.state.container.parentNode.classList.contains('medium-6' || 'large-6');

    if (this.state.showAsInPageWizardTool) {
      return;
    }

    if (!this.state.isSticky && nextProps.currentStep >= 1 && isWidget) {
      document.querySelector("main").style.minHeight = document.querySelector("main").clientHeight + "px";
      this.setState({
        isSticky: true,
        mainHeight: document.querySelector("main").clientHeight
      });
    } else if (nextProps.currentStep === 0) {
      document.querySelector("main").style.minHeight = "initial";
      this.setState({ isSticky: false, mainHeight: "initial" });
    }
  }

  componentDidMount() {
    if (typeof window !== "undefined") {

      if (!this.state.showAsInPageWizardTool) {
        window.addEventListener("resize", this.handleResize);
      }
      
      this.setState({
        container: ReactDOM.findDOMNode(this).parentNode,
        modalCloseText: window.globalStrings.modalCloseText
      });
    }
  }

  componentDidUpdate() {
    if (typeof window !== "undefined") {
      if (this.props.currentStep >= 1) {
        if (!this.state.hackBrowserBackBtn) {
          this.hackBrowserBackBtn();
        }
      } else if (this.props.currentStep < 1 && this.state.hackBrowserBackBtn) {
        this.unHackBrowserBackBtn();
      }
    }
  }

  goToStep() {
    this.props.setPreviousQuestion(this.props.currentStep);
    const nextStep = this.props.currentStep - 1;
    this.props.goToStep(nextStep);
  }

  hackBrowserBackBtn() {
    const that = this;
    history.pushState(null, null, null);

    $(window).on("popstate", function (event) {
      if (!event.originalEvent.state) {
        history.pushState(null, null, null);
        that.goToStep();
        return;
      }
    });

    this.setState({ hackBrowserBackBtn: true });
  }

  unHackBrowserBackBtn() {
    $(window).off("popstate");
    this.setState({ hackBrowserBackBtn: false });
  }

  componentWillMount() {
    this.loadMapsAPI();
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  handleResize() {

    if (this.state.showAsInPageWizardTool)
      return;

    if (this.props.currentStep > 0) {
      let top;

      if (!window.matchMedia("(min-width: 1200px)").matches) {
        //TODO MATCH MEDIA
        top = document.querySelector(".mobile-header").getBoundingClientRect().height;
      } else {
        top = document.querySelector("#main-menu-border").getBoundingClientRect().bottom - 1;
      }

      if (this.state.wizardToolTopY !== top) {
        this.setState({ wizardToolTopY: top });
      }
    }
  }

  calcStyles() {
    if (this.state.showAsInPageWizardTool)
      return {};

    let top;

    if (!window.matchMedia("(min-width: 1200px)").matches) {
      //TODO MATCH MEDIA
      top = document.querySelector(".mobile-header").getBoundingClientRect()
        .height;
    } else {
      top = document.querySelector("#main-menu-border").getBoundingClientRect()
        .bottom - 1;
    }

    let styles = {
      top: top + "px"
    };

    return styles;
  }

  closeModal() {
    this.props.setPreviousQuestion(this.props.currentStep);
    this.props.goToStep(0);
    this.closePopUp();
  }

  loadMapsAPI() {
    const dataUrl = this.props.quizSettings.GoogleMapSettings.LibraryUrl;

    let data = webservice.loadMapsAPI(dataUrl);

    data.then(request => {
      this.props.setMapsAPI(true);
    });
  }

  closePopUp() {
    let wizardCookieCheck = shvenergy.cookies.getCookie("_shvenergy_resume_wizard_tool");
    let cookiePopUpExist = document.querySelector(".quote-box");

    if (!wizardCookieCheck && cookiePopUpExist) {
      cookiePopUpExist.remove();
    }
  }

  render() {
    let isWidget = false;

    if (this.state.container) {
      if (this.state.container.parentNode.classList.contains('medium-6' || 'large-6') && this.props.Settings.ShowAsInPageWizardTool) {
        isWidget = true;
      }
    }

    let qs = this.props.quizSettings;
    let bg = `wizard-tool ${this.props.Settings.BackgroundColor} ${this.props.Settings.ShowAsInPageWizardTool ? "inline":""}`; // css class. Will return either "wizard-tool-background-color-grey" or "wizard-tool-background-color-white"

    if (
      qs.Items[qs.Items.length - 1].Header !==
      "Sorry, an error occurred. Please try again"
    ) {
      let qsFakeStep = { Header: "Sorry, an error occurred. Please try again" };
      qs.Items.push(qsFakeStep);
    }

    let item = qs.Items[qs.Items.length - 2];
    let currentStep = this.props.currentStep;

    let styles = !this.state.showAsInPageWizardTool && currentStep > 0 ? {zIndex: "9999"} : { position: "relative", zIndex: "0" };

    if (typeof window !== "undefined") {
      if (this.state.isSticky && !this.state.showAsInPageWizardTool) {

        if (!isWidget) {
          document.querySelector("html").classList.add("ishidden");
        }

        shvenergy.mobilefixedheader.disableScrollPosition();
        document.querySelector(".mobile-header__sticky").classList.add("is-stuck");

        styles = this.calcStyles();
        let that = this;

        setTimeout(function () {
          that.handleResize();
        }, 100);
      } else {
        document.querySelector("html").classList.remove("ishidden");
        shvenergy.mobilefixedheader.enableScrollPosition();
      }
    }

    let isWizardClass = isWidget ? 'isWidget' : 'notWidget';
    let wizardToolStepIndicatorClasses = ((currentStep === 0 || this.state.showAsInPageWizardTool) ? "" : "sticky ");
    let remainingValue = qs.Items[this.props.currentStep].TotalItems - qs.Items[this.props.currentStep].CurrentItem;
    
    return (
      <div>
        {qs && (
          <div style={styles} className={'containerStyles ' + bg + ' ' + isWizardClass}>
            <div className="wizard-tool__wrapper" data-wizard-id={this.props.Id}>
              <div className="container">
                {currentStep > 0 && (
                  <button
                    type="button"
                    id={this.props.quizSettings.closeTrackingId}
                    className="modal-close"
                    onClick={this.closeModal}
                  >
                    <span className="modal-close__inner">
                      <span id="modal-close-label">
                        {this.state.modalCloseText}
                      </span>
                      <svg
                        className="close"
                        aria-hidden="true"
                        focusable="false"
                        width="16"
                        height="16"
                        dangerouslySetInnerHTML={{
                          __html:
                            '<use xlink:href="/dist/svgsprite/icons.svg#X_16x16"/>'
                        }}
                      />
                    </span>
                  </button>
                )}
                {qs.Items.map((step, idx) => {
                  return (
                    <WizardToolQuestionWrapper
                      key={idx}
                      data={step}
                      index={idx}
                      quizSettings={qs}
                      mapsAPIloaded={this.props.mapsAPIloaded}
                      remainingValue={remainingValue}
                      SpinnerBGColor={this.props.SpinnerBGColor}
                      SpinnerMessageIntervals={this.props.SpinnerMessageIntervals}
                      SpinnerMessages={this.props.SpinnerMessages}
                      SpinnerEnable={this.props.SpinnerEnable}
                    />
                  );
                })}
              </div>
            </div>
            <WizardToolStepIndicator
              data={item}
              classes={wizardToolStepIndicatorClasses}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    quizSettings: quizSelector.quizSettings(state),
    useDummyData: quizSelector.useDummyData(state),
    previousQuestion: quizSelector.previousQuestion(state),
    goToRev: quizSelector.goToRev(state),
    currentStep: quizSelector.getCurrentStep(state),
    mapsAPIloaded: quizSelector.mapsAPIloaded(state)
  };
};

const mapDispatchToProps = {
  setQuizData,
  goToStep,
  setPreviousQuestion,
  setMapsAPI
};

WizardTool = connect(
  mapStateToProps,
  mapDispatchToProps
)(WizardTool);
export default WizardTool;
